import { render, staticRenderFns } from "./bill-address-detail.vue?vue&type=template&id=23fc8c65"
import script from "./bill-address-detail.vue?vue&type=script&lang=js"
export * from "./bill-address-detail.vue?vue&type=script&lang=js"
import style0 from "./bill-address-detail.vue?vue&type=style&index=0&id=23fc8c65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports